
import './index.scss';
import { Parallax } from 'rc-scroll-anim';
import {IMGURL} from 'lib/config'

interface IImgsInfo{
  mainImg : string;
  subImg : string;
  xy : {
    x : number;
    y : number;
  }
}
interface IProps {
  dataInfo : {
    title : string;
    data : IImgsInfo[]
  }
}
const CarInsure = (props: IProps) => {
  const {title,data} = props.dataInfo;
  return (
    <div className='car_insure_wrap'>
      <div className="title">{title}</div>
      <Parallax
        animation={{ x: 0, opacity: 1, playScale: [0, 0.6] }}
        style={{ transform: 'translateX(-100px)', opacity: 0 }}
        className="left_img_box"
        // @ts-ignore
        always = {false} 
      >
        <img src={`${IMGURL}${data[0].mainImg}`} alt="img" className='left_img'/>
      </Parallax>
      <Parallax
        animation={{ x: '100px', opacity: 1, playScale: [0, 0.6] }}
        style={{ transform: 'translateX(800px)', opacity: 0 }}
        className="right_img_box"
        // @ts-ignore
        always = {false} 
      >
        <img src={`${IMGURL}${data[0].subImg}`} alt="img" className='right_img'/>
      </Parallax>
    </div>
  );
};

export default CarInsure;
